import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "px-4 lg:px-0" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center items-center h-[80vh]"
}
const _hoisted_3 = { class: "flex flex-col lg:flex-row justify-center items-center max-w-[51.25rem] w-full mt-20" }
const _hoisted_4 = { class: "w-full lg:w-4/6" }
const _hoisted_5 = { class: "flex justify-start items-center cursor-pointer mt-2" }
const _hoisted_6 = { class: "w-full lg:w-2/6 mt-8 lg:mt-0 lg:ml-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "mx-6 lg:mx-[5.25rem]" }
const _hoisted_10 = { class: "flex justify-center mb-[9.25rem]" }
const _hoisted_11 = { class: "flex flex-col mt-6 pt-2 pb-12 px-4 md:px-24 xl:pl-10 xl:pr-12 bg-[#F2F4F7] rounded-xl w-full md:max-w-5xl" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "flex flex-col md:flex-row justify-around items-center" }
const _hoisted_14 = { class: "flex flex-col items-center md:items-start items-start text-center md:text-left justify-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-xl leading-7 text-[#101828] break-words mt-2 md:mt-0" }, " ต้องการความช่วยเหลือในการจัดการ Cookie Consent เพื่อรวบรวมพฤติกรรมของลูกค้าของคุณอย่างถูกต้อง ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-base leading-6 text-[#475467] break-words mt-2 md:mt-0" }, " สร้าง, ปรับแต่ง Cookie Consent Banner ให้กับเว็บไซต์ของคุณ และ จัดการข้อมูล Cookie Consent อย่างมืออาชีพ ", -1)
const _hoisted_17 = { class: "flex flex-col md:flex-row items-center mt-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-5 font-semibold" }, [
  /*#__PURE__*/_createTextVNode(" เพียง "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#F26634] text-2xl leading-8 font-bold mx-1" }, " 165.83 บาท "),
  /*#__PURE__*/_createTextVNode(" ต่อเดือน ")
], -1)
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs md:text-base leading-5 md:leading-7 font-medium text-white mt-1 ml-2 break-words" }, " สมัครใช้งาน ", -1)
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scanner_header = _resolveComponent("scanner-header")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_scanning = _resolveComponent("scanning")!
  const _component_cookie_detail = _resolveComponent("cookie-detail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state === 'SCANNER')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_scanner_header),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_n_input, {
                placeholder: "https://sable.asia",
                value: _ctx.targetUrl,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetUrl) = $event)),
                class: "urlInput rounded-lg py-2 lg:py-[1.125rem] px-3 border border-gray-300 text-left disabled:bg-gray-200 hover:border-[#F26634]",
                disabled: _ctx.disableInput,
                "input-props": { type: 'url', name: 'url' },
                onKeydown: _withKeys(_ctx.createScannerJob, ["enter"]),
                autocomplete: ""
              }, null, 8, ["value", "disabled", "onKeydown"]),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "accept",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.disableButton) = $event)),
                  class: "accent-[#F26634]"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.disableButton]
                ]),
                _createElementVNode("span", {
                  class: "font-normal text-sm leading-5 ml-2 select-none",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disableButton = !_ctx.disableButton))
                }, " คุณยินยอมให้เราสแกน website ของคุณ ")
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_n_spin, { show: _ctx.disableInput }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    size: "large",
                    class: _normalizeClass(["flex items-center justify-center lg:mb-7 rounded-lg bg-[#F26634] px-8 py-3 lg:py-5 max-h-[3rem] lg:max-h-[4.75rem] w-full", [
                _ctx.disableInput || !_ctx.disableButton ? 'bg-gray-200' : 'bg-[#F26634]',
              ]]),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createScannerJob && _ctx.createScannerJob(...args))),
                    disabled: _ctx.disableInput || !_ctx.disableButton
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-white font-medium lg:font-semibold text-base lg:text-2xl leading-8", [
                  _ctx.disableInput || !_ctx.disableButton
                    ? 'bg-gray-200 text-gray-400'
                    : 'bg-[#F26634] text-white',
                ]])
                    }, " สแกนคุกกี้ ", 2)
                  ], 10, _hoisted_7)
                ]),
                _: 1
              }, 8, ["show"])
            ])
          ])
        ]))
      : (_ctx.state === 'SCANNING')
        ? (_openBlock(), _createBlock(_component_scanning, {
            key: 1,
            percentage: _ctx.scanJob?.progress ?? 0
          }, null, 8, ["percentage"]))
        : (_ctx.state === 'RESULT')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_cookie_detail, {
                  cookies: _ctx.cookies,
                  jobId: _ctx.jobId,
                  url: _ctx.scanJob?.url,
                  totalPageScanned: _ctx.scanJob?.totalPageScanned,
                  totalCookiesFound: _ctx.scanJob?.totalCookiesFound,
                  totalMarketingCookiesFound: _ctx.scanJob?.totalMarketingCookiesFound,
                  totalAnalyticsCookiesFound: _ctx.scanJob?.totalAnalyticsCookiesFound,
                  totalFunctionalCookiesFound: _ctx.scanJob?.totalFunctionalCookiesFound,
                  totalUnknownCookiesFound: _ctx.scanJob?.totalUnknownCookiesFound,
                  dateGenerate: _ctx.scanJob?.startDate
                }, null, 8, ["cookies", "jobId", "url", "totalPageScanned", "totalCookiesFound", "totalMarketingCookiesFound", "totalAnalyticsCookiesFound", "totalFunctionalCookiesFound", "totalUnknownCookiesFound", "dateGenerate"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openLink('https://sable.asia'))),
                    class: "flex bg-[#DDE0E4] rounded max-w-[11.5rem] w-full place-self-end items-center font-medium text-xs leading-[1.125rem] text-[#475467] py-1 px-2 mb-4 cursor-pointer"
                  }, [
                    _createTextVNode(" ได้รับการสนันสนุนจาก SABLE "),
                    _createElementVNode("img", {
                      src: '/images/info.svg',
                      class: "w-3 h-3 self-center ml-1.5"
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("span", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openLink('https://sable.asia/sable-consent/'))),
                          class: "bg-[#4D7EE0] hover:bg-[#4775D2] flex-row items-center justify-center md:justify-start rounded px-2 md:px-4 py-2.5 flex item-center mt-4 md:mt-0 md:ml-6 w-full md:w-auto cursor-pointer"
                        }, [
                          _createElementVNode("img", {
                            src: '/images/protect.svg',
                            class: "w-[1.125rem] h-[1.375rem] self-center"
                          }, null, 8, _hoisted_19),
                          _hoisted_20
                        ])
                      ])
                    ]),
                    _createElementVNode("img", {
                      src: '/images/Sable_Cookie.png',
                      class: "w-[21.9375rem] h-[14.625rem] self-center rounded-md border-4 border-[#101828] md:ml-8 mt-8 md:mt-0"
                    }, null, 8, _hoisted_21)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, "Something went wrong!!!"))
  ]))
}